// Slug canônico de tipo de evento (espelho de supabase/functions/_shared/schedule-template.ts
// e de public.briefing_ids_visiveis()).
//
// `eventos.tipo_evento` é texto livre de propósito: novos tipos (batizado, bodas,
// bar mitzvah…) entram sem enum nem FK. Aqui só apelidamos variantes conhecidas
// do MESMO tipo para um único valor, para comparações confiáveis.

export function tipoEventoCanonico(raw: string | null | undefined): string {
  const t = String(raw ?? '').trim().toLowerCase().replace(/\s+/g, '-').replace(/_/g, '-');
  switch (t) {
    case 'aniversario-15':
    case 'quinze-anos':
    case '15-anos':
    case 'debutante':
      return 'aniversario_15';
    default:
      return t.replace(/-/g, '_');
  }
}

export function mesmoTipoEvento(a: string | null | undefined, b: string | null | undefined): boolean {
  const ca = tipoEventoCanonico(a);
  const cb = tipoEventoCanonico(b);
  return ca !== '' && ca === cb;
}

const ROTULOS: Record<string, string> = {
  casamento: 'Casamento',
  aniversario_15: '15 Anos',
  aniversario: 'Aniversário',
  corporativo: 'Corporativo',
  formatura: 'Formatura',
  infantil: 'Infantil',
  batizado: 'Batizado',
  bodas: 'Bodas',
  outros: 'Outros',
};

export function rotuloTipoEvento(raw: string | null | undefined): string {
  const canon = tipoEventoCanonico(raw);
  if (!canon) return 'Evento';
  return ROTULOS[canon] ?? canon.replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase());
}
